/**
 * 编辑资料页懒加载壳（14.29b；GroupNoticeLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function MyProfileLazy() {
  const { mod } = useLazyModule(() => import('./MyProfilePage'));
  if (mod === null) return <div data-testid="my-profile-loading-shell">加载中…</div>;
  return <mod.MyProfilePage />;
}
